import Autocomplete from './datalist';
import React from 'react';
import MetadataLayout from '../form-input/layout-metadata';

export default function(props) {
  return <MetadataLayout {...props}>
    <Autocomplete {...props}/>
  </MetadataLayout>
}
